import { getTenantSubdomainFromHostname } from "~/utils/public-store-host"

export default defineNuxtRouteMiddleware(async (to) => {
	const config = useRuntimeConfig()
	const baseDomain = String(config.public.baseDomain || "").toLowerCase()
	const hostname =
		typeof window !== "undefined"
			? String(window.location.hostname || "").toLowerCase()
			: ""
	const subdomain = getTenantSubdomainFromHostname(hostname, baseDomain, {
		appSubdomain: config.public.appSubdomain,
		reservedSubdomains: config.public.reservedSubdomains,
	})
	const isSubdomainHost = Boolean(subdomain)

	if (isSubdomainHost) return

	const { data: auth } = useAuth()
	if (!auth.value) return

	const role = auth.value.role
	const posRequested = to.query.pos === "1"

	// Check if there's a pos selected
	if (typeof window !== "undefined") {
		// Any user that has a role of "None" should go to /register
		if (role === "None") {
			return await navigateTo("/register")
		}

		if ((role === "Owner" || role === "Super") && !posRequested) {
			return await navigateTo("/admin")
		}

		// Only allow to choose POS if you have pos permission
		const posDeviceId = localStorage.getItem("sv_pos_device_id")
		if (posDeviceId == null && (auth.value.pos_perms || []).includes("POS")) {
			return await navigateTo("/pos/device-id")
		}
	}
})
